import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { DatePicker } from '../ui/DatePicker';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import EmployeeMultiSelect from './EmployeeMultiSelect';

const PointagesBrutsFiltersCard = ({
  dateRange, handleDateChange,
  selectedDepartment, setSelectedDepartment, setCurrentPage,
  departments,
  filterType, setFilterType,
  searchTerm, setSearchTerm,
  employeesOptions, selectedEmployees, handleEmployeesFilterChange,
  employeesLoading, employeesReady,
  handleApplyFilters,
}) => {
  const { t } = useTranslation();
  return (
  <Card>
    <CardHeader>
      <CardTitle>{t('pointages.filters.title')}</CardTitle>
      <CardDescription>{t('pointages.filters.subtitle')}</CardDescription>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <Label>{t('pointages.filters.startDate')}</Label>
          <DatePicker value={dateRange.start} onChange={(v) => handleDateChange('start', v)} />
        </div>
        <div>
          <Label>{t('pointages.filters.endDate')}</Label>
          <DatePicker value={dateRange.end} onChange={(v) => handleDateChange('end', v)} />
        </div>
        <div>
          <Label>{t('pointages.filters.department')}</Label>
          <Select
            value={selectedDepartment ? String(selectedDepartment) : 'all'}
            onValueChange={(value) => {
              setSelectedDepartment(value === 'all' ? null : Number(value));
              setCurrentPage(1);
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder={t('pointages.filters.allDepartments')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('pointages.filters.allDepartments')}</SelectItem>
              {departments.map((dept) => (
                <SelectItem key={dept.id} value={String(dept.id)}>{dept.name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>{t('pointages.filters.punchType')}</Label>
          <Select value={filterType} onValueChange={setFilterType}>
            <SelectTrigger>
              <SelectValue placeholder={t('pointages.filters.punchType')} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{t('pointages.filters.allTypes')}</SelectItem>
              <SelectItem value="entree">{t('pointages.filters.entries')}</SelectItem>
              <SelectItem value="sortie">{t('pointages.filters.exits')}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        <div>
          <Label>{t('pointages.filters.searchEmployee')}</Label>
          <Input
            placeholder={t('pointages.filters.searchPlaceholder')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div>
          <Label>{t('pointages.filters.employeesByDept')}</Label>
          <EmployeeMultiSelect
            employees={employeesOptions}
            selectedIds={selectedEmployees}
            onChange={handleEmployeesFilterChange}
            disabled={employeesLoading}
          />
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={handleApplyFilters} disabled={!employeesReady || employeesLoading}>
          {t('pointages.filters.apply')}
        </Button>
      </div>
    </CardContent>
  </Card>
  );
};

export default PointagesBrutsFiltersCard;
